import { AulaPlugin } from '../plugins';
import { handleCutCopy } from '../../lib/handleCutCopy';

export const handleCopy: AulaPlugin = (editableProps, editor, context) => {
  if (context == null) {
    throw new Error('context must be defined');
  }
  return {
    ...editableProps,
    onCopy: (event: React.ClipboardEvent) => {
      handleCutCopy(event, editor, context);
    },
    onCut: (event: React.ClipboardEvent) => {
      handleCutCopy(event, editor, context);
    },
  };
};
